import { MDMaterialStateTypes, MDMaterialActionTypes } from "./MDMaterial.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MDMaterialStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MDMaterialReducer = (
  state: MDMaterialStateTypes = INITIAL_STATE,
  action: any
): MDMaterialStateTypes => {
  switch (action.type) {
    case MDMaterialActionTypes.FETCH_ALL_MDMATERIAL:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MDMaterialActionTypes.FETCH_ALL_MDMATERIAL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MDMaterialActionTypes.FETCH_ALL_MDMATERIAL_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MDMaterialActionTypes.FETCH_ALL_MDMATERIAL_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MDMaterialActionTypes.FETCH_ONE_MDMATERIAL:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MDMaterialActionTypes.FETCH_ONE_MDMATERIAL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MDMaterialActionTypes.FETCH_ONE_MDMATERIAL_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MDMaterialActionTypes.FETCH_ONE_MDMATERIAL_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MDMaterialReducer;
